module.exports = __webpack_public_path__ + "img/gb.e5564902.svg";